import m from "./../../../dist/es2015/locales/bs_BA.js";
export const am5locales_bs_BA = m;